// extracted by mini-css-extract-plugin
export var link = "_u1-0";